import React from "react";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import Select from "react-select";
import moment from "moment";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  Col,
  Tab,
  Modal,
  Row,
  Accordion,
  OverlayTrigger,
  Tooltip,
  Container,
} from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import { useDispatch, useSelector } from "react-redux";
import { Document, Page, pdfjs } from "react-pdf";
import { revisiPengajuan } from "stores/Pengajuan/function";
import { pengajuanBPD } from "stores/Pengajuan/function";
import Moment from "moment";
import { getAllPengajuan } from "stores/Pengajuan/function";
import { number } from "prop-types";
import { updateStatusManual } from "stores/Pengajuan/function";
import CurrencyInput from "react-currency-input-field";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import Ringkasan from "./ListUsaha";
import Scoring from "./Scoring";

function indexSteps() {
  const dispatch = useDispatch();
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const auth = useSelector((state) => state.authReducer);
  // console.log(pengajuan, "DARI STORE");
  const [listUrlDokumen, setListUrlDokumen] = React.useState([]);
  const valDetailStepEnam = !pengajuan.detailPengajuan.stepEnam
    ? []
    : pengajuan.detailPengajuan.stepEnam;
  const valDetail = pengajuan.detailPengajuan;
  const detailLocalStorage = localStorage.getItem("detailPengajuan");

  // console.log(valDetail, "KKK");
  const urlPreview = pengajuan.urlDokumen;
  const judulPdf = pengajuan.titlePreview;
  const [modalRevisi, setModalRevisi] = React.useState(false);
  const [keterangan, setKeterangan] = React.useState("");
  const [idPengajuan, setIdPengajuan] = React.useState("");
  const [modalUpdateStatus, setModalUpdateStatus] = React.useState(false);
  const [keteranganUpdate, setKeteranganUpdate] = React.useState("");
  const [nominalPencairan, setNominalPencairan] = React.useState("");
  const [noAkad, setNoAkad] = React.useState("");
  const [tanggalAkad, setTanggalAkad] = React.useState("");
  const [noAgenda, setNoAgenda] = React.useState("");
  const [tanggalAgenda, setTanggalAgenda] = React.useState("");
  const [status, setStatus] = React.useState("");

  React.useEffect(() => {
    let tmp = [];
    Object.entries(valDetailStepEnam).forEach(([key, value]) => {
      if (
        key != "_id" &&
        key != "id_pinjaman" &&
        key != "createdAt" &&
        key != "updatedAt"
      ) {
        tmp.push({
          key: key,
          url: value,
        });
      }
    });
    setListUrlDokumen(tmp);
  }, []);

  // const ajukanPengajuan = () => {
  //   Swal.fire({
  //     title: "Konfirmasi Pengajuan",
  //     text: "Pastikan data yang anda ajukan benar !!!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Ya, Ajukan",
  //     cancelButtonText: "Batal",
  //     allowOutsideClick: () => !Swal.isLoading(),
  //     showLoaderOnConfirm: true,
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       pengajuanBPD({
  //         idPengajuan: valDetail.id_pinjaman,
  //       })
  //         .then((response) => {
  //           if (response.data.status === 200) {
  //             dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
  //             Swal.fire({
  //               title: "Berhasil",
  //               text: response.data.message,
  //               icon: "success",
  //             });
  //           } else {
  //             Swal.fire({
  //               title: "Error",
  //               text: response.data.message,
  //               icon: "error",
  //             });
  //           }
  //         })
  //         .catch((err) => {
  //           console.log("ERRORRRRR", err);
  //           Swal.fire({
  //             title: "Error",
  //             text: "Terjadi kesalahan saat mengajukan pengajuan.",
  //             icon: "error",
  //           });
  //         });
  //     }
  //   });
  // };

  const ajukanPengajuan = () => {
    Swal.fire({
      title: "Konfirmasi Pengajuan",
      text: "Pastikan data yang anda ajukan benar !!!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya, Ajukan",
      cancelButtonText: "Batal",
      allowOutsideClick: () => !Swal.isLoading(),
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Mengajukan...",
          text: "Mohon tunggu, pengajuan Anda sedang diproses.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        pengajuanBPD({
          idPengajuan: valDetail.id_pinjaman,
        })
          .then((response) => {
            // console.log(response, "RES");
            Swal.close();
            if (response.data.status === 200) {
              dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
              Swal.fire({
                title: "Berhasil",
                text: response.data.message,
                icon: "success",
              });
            } else if (response.data.status === 400) {
              Swal.fire({
                title: "Error",
                text: response.data.message,
                icon: "error",
              });
            }
          })
          .catch((err) => {
            Swal.close();
            console.log("ERRORRRRR", err);
            Swal.fire({
              title: "Error",
              text: "Terjadi kesalahan saat mengajukan pengajuan.",
              icon: "error",
            });
          });
      }
    });
  };
  {
  }
  const handleClick = (idPengajuanValue) => {
    setIdPengajuan(idPengajuanValue);
    dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
    localStorage.removeItem("lastPage");
    localStorage.removeItem("detailPengajuan");
    dispatch({ type: "SET_CLOSE_TAB", data: false });
    dispatch({
      type: "SET_LAST_TAB",
      data: !valDetail.stepEmpat.kategoriKredit
        ? "konvensional"
        : valDetail.stepEmpat.kategoriKredit,
    });
  };

  const submitRevisi = () => {
    if (keterangan === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Keterangan tidak boleh kosong",
      });
    } else {
      revisiPengajuan({
        idPengajuan: idPengajuan,
        keterangan: keterangan,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
          }).then(() => {
            dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
          });
          setTimeout(() => {
            Swal.close();
          }, 5000);
          setModalRevisi(false);
          getAllPengajuan(dispatch, { status: "" });
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const submitUpdateStatus = (e) => {
    e.preventDefault();
    if (status === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Status tidak boleh kosong",
      });
    } else {
      if (status.value === "Disetujui") {
        if (
          nominalPencairan === 0 ||
          noAkad === "" ||
          tanggalAkad === "" ||
          noAgenda === "" ||
          tanggalAgenda === ""
        ) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Wajib di isi semua!",
          });
        } else {
          updateStatusManual({
            idPinjaman: idPengajuan,
            statusPengajuan: status.value,
            nominalPencairan: nominalPencairan,
            noAkad: noAkad,
            noAgenda: noAgenda,
            tglAkad: tanggalAkad,
            tglAgenda: tanggalAgenda,
          }).then((response) => {
            // console.log(response, "TESSSSSSSSSSSSSSS");
            if (response.data.status === 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
              }).then((response) => {
                setModalUpdateStatus(false);
                setStatus("");
                setNoAgenda("");
                setNoAkad("");
                setNominalPencairan("");
                setTanggalAgenda("");
                setTanggalAkad("");
                getAllPengajuan(dispatch, { status: "" });
                dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
              });
              setTimeout(() => {
                Swal.close();
              }, 1000);
            } else if (response.data.status === 400) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.data.message,
              });
            }
          });
        }
      } else {
        if (keteranganUpdate === "") {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Keterangan tidak boleh kosong",
          });
        } else {
          updateStatusManual({
            idPinjaman: idPengajuan,
            statusPengajuan: status.value,
            keterangan: keteranganUpdate,
            nominalPencairan: nominalPencairan,
            noAkad: noAkad,
            tglAkad: tanggalAkad,
            noAgenda: noAgenda,
            tglAgenda: tanggalAgenda,
          }).then((response) => {
            if (response.data.status === 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
              }).then(() => {
                setModalUpdateStatus(false);
                setKeterangan("");
                setStatus("");
                setNoAgenda("");
                setNoAkad("");
                setNominalPencairan("");
                setTanggalAgenda("");
                setTanggalAkad("");
                getAllPengajuan(dispatch, { status: "" });
                dispatch({ type: "SET_STEP_PENGAJUAN", data: true });
              });
              setTimeout(() => {
                Swal.close();
              }, 1000);
            } else if (response.data.status === 400) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.data.message,
              });
            }
          });
        }
      }
    }
  };

  const handleCloseModalUpdatStatus = () => {
    setStatus("");
    setKeterangan("");
    setNominalPencairan("");
    setNoAkad("");
    setTanggalAkad("");
    setNoAgenda("");
    setTanggalAgenda("");
  };

  const statusStyle = (status) => {
    switch (status) {
      case "Menunggu Konfirmasi":
        return { backgroundColor: "#FFF5CD", textColor: "#FFAF05" };
      case "Diajukan":
        return { backgroundColor: "#BAD9FD", textColor: "#1776F1" };
      case "Diproses":
        return { backgroundColor: "#fcceb3", textColor: "#fa5d02" };
      case "Disetujui":
        return { backgroundColor: "#E3FCDB", textColor: "#5AC967" };
      case "Revisi":
        return { backgroundColor: "#FFE2E6", textColor: "#FF2B4B" };
      case "Ditolak":
        return { backgroundColor: "#E10F00", textColor: "#ffffff" };
      default:
        return {};
    }
  };

  const options = [
    {
      value: "",
      label: "Pilih Status",
      isDisabled: true,
    },
    {
      value: "Menunggu Konfirmasi",
      label: "Menunggu Konfirmasi",
    },
    // {
    //   value: "Disetujui",
    //   label: "Disetujui",
    // },
    {
      value: "Ditolak",
      label: "Ditolak",
    },
  ];

  // const submitRevisi = () => {
  //   if (keterangan === "") {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Keterangan tidak boleh kosong",
  //     });
  //   } else {
  //     revisiPengajuan({
  //       idPengajuan: idPengajuan,
  //       keterangan: keterangan,
  //     }).then((response) => {
  //       if (response.data.status === 200) {
  //         Swal.fire({
  //           position: "center",
  //           icon: "success",
  //           title: response.data.message,
  //         });
  //         setTimeout(() => {
  //           Swal.close();
  //         }, 5000);
  //         setModalRevisi(false);
  //       } else if (response.data.status === 400) {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: response.data.message,
  //         });
  //       }
  //     });
  //   }
  // };

  return (
    <>
      <Modal
        size="lg"
        show={modalUpdateStatus}
        onHide={() => {
          setModalUpdateStatus(false);
          handleCloseModalUpdatStatus();
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="12">
              <Form action="" className="form" method="">
                <Card>
                  <Card.Header>
                    <Card.Header>
                      <Card.Title as="h4" style={{ fontWeight: "bold" }}>
                        Update Status
                      </Card.Title>
                    </Card.Header>
                  </Card.Header>
                  <Card.Body>
                    <Row>
                      <Col sm="12">
                        <Form.Group>
                          <label
                            style={{
                              fontWeight: "bold",
                              fontSize: 14,
                              color: "grey",
                              textTransform: "none",
                            }}
                          >
                            Status
                          </label>
                          <Select
                            className="react-select primary"
                            classNamePrefix="react-select"
                            name="singleStatus"
                            onChange={(value) => setStatus(value)}
                            options={options}
                            placeholder="Pilih Status"
                          />
                        </Form.Group>
                      </Col>
                      {status.value === "Menunggu Konfirmasi" ||
                      status.value === "Diproses" ||
                      status.value === "Revisi" ||
                      status.value === "Ditolak" ? (
                        <Col sm="12">
                          <Form.Group>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "grey",
                                textTransform: "none",
                              }}
                            >
                              Keterangan
                            </label>
                            <Form.Control
                              as="textarea"
                              onChange={(e) => {
                                setKeteranganUpdate(e.target.value);
                              }}
                              rows={4}
                              className="form-control"
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                      {status.value === "Disetujui" ? (
                        <Col sm="12">
                          <Form.Group>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "grey",
                                textTransform: "none",
                              }}
                            >
                              Nominal Pencairan
                            </label>
                            <p>
                              <CurrencyInput
                                style={{
                                  padding: 5,
                                  borderRadius: 4,
                                  width: "100%",
                                  height: "40px",
                                  borderWidth: "1px",
                                  borderTopColor: "rgba(227, 227, 227, 0.3)",
                                  borderLeftColor: "rgba(227, 227, 227, 0.3)",
                                  borderBottomColor: "rgba(227, 227, 227, 1)",
                                  borderRightColor: "rgba(227, 227, 227, 1)",
                                }}
                                name="nominal"
                                placeholder="Masukkan nominal"
                                prefix="Rp "
                                onValueChange={(value) => {
                                  setNominalPencairan(value);
                                }}
                              />
                            </p>
                          </Form.Group>
                        </Col>
                      ) : null}
                      {status.value === "Disetujui" ? (
                        <Col sm="12">
                          <Form.Group>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "grey",
                                textTransform: "none",
                              }}
                            >
                              No Akad
                            </label>
                            <Form.Control
                              onChange={(e) => {
                                setNoAkad(e.target.value);
                              }}
                              type="text"
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                      {status.value === "Disetujui" ? (
                        <Col sm="12">
                          <Form.Group>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "grey",
                                textTransform: "none",
                              }}
                            >
                              Tanggal Akad
                            </label>
                            <Form.Control
                              onChange={(e) => {
                                setTanggalAkad(e.target.value);
                              }}
                              type="date"
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                      {status.value === "Disetujui" ? (
                        <Col sm="12">
                          <Form.Group>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "grey",
                                textTransform: "none",
                              }}
                            >
                              No Agenda
                            </label>
                            <Form.Control
                              onChange={(e) => {
                                setNoAgenda(e.target.value);
                              }}
                              type="text"
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                      {status.value === "Disetujui" ? (
                        <Col sm="12">
                          <Form.Group>
                            <label
                              style={{
                                fontWeight: "bold",
                                fontSize: 14,
                                color: "grey",
                                textTransform: "none",
                              }}
                            >
                              Tanggal Agenda
                            </label>
                            <Form.Control
                              onChange={(e) => {
                                setTanggalAgenda(e.target.value);
                              }}
                              type="date"
                            />
                          </Form.Group>
                        </Col>
                      ) : null}
                    </Row>

                    <Button
                      className="btn-fill pull-right"
                      type="submit"
                      variant="info"
                      onClick={submitUpdateStatus}
                    >
                      Submit
                    </Button>
                    <div className="clearfix"></div>
                  </Card.Body>
                </Card>
              </Form>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalRevisi}
        onHide={() => {
          setModalRevisi(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md={"12"} style={{ marginTop: 20 }}>
          <Card className="stacked-form">
            <Card.Header>
              <Card.Title as="h4" style={{ fontWeight: "bold" }}>
                Note Revisi
              </Card.Title>
            </Card.Header>
            <Card.Body>
              <Col sm="12">
                <Form.Control
                  as="textarea"
                  rows={4}
                  onChange={(e) => {
                    setKeterangan(e.target.value);
                  }}
                ></Form.Control>
                <Form.Text
                  className="text-muted"
                  style={{ color: "black", fontWeight: "bold" }}
                >
                  Note Revisi Apa Saja Yang Diperlukan
                </Form.Text>
              </Col>
            </Card.Body>
            <Card.Footer>
              <Button
                className="btn-wd mr-0"
                variant="primary"
                onClick={submitRevisi}
              >
                Submit
              </Button>
            </Card.Footer>
          </Card>
        </Col>
      </Modal>

      <Container fluid className="pt-3">
        <Row>
          {/* BAGIAN UTAMA DETAIL */}
          <Col lg={pengajuan.valueCol} md="12">
            <Card
              className="border-0 shadow-sm"
              style={{ borderRadius: "20px" }}
            >
              {/* HEADER: Navigasi & Judul */}
              <Card.Header className="bg-white border-0 pt-4 px-4 d-flex flex-column flex-md-row align-items-center justify-content-between">
                <div className="d-flex align-items-center mb-3 mb-md-0">
                  <Button
                    className="btn-icon shadow-sm mr-3 d-flex align-items-center justify-content-center"
                    type="button"
                    variant="white"
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "12px",
                      border: "none",
                      backgroundColor: "#F1F5F9",
                      color: "#1D3557",
                      flexShrink: 0, // Mencegah tombol gepeng saat layar kecil
                    }}
                    onClick={handleClick}
                  >
                    <i
                      className="fas fa-arrow-left"
                      style={{ fontSize: "18px" }}
                    ></i>
                  </Button>

                  {/* TEXT CONTAINER - Menggunakan flex-column agar Judul & ID rapi ke bawah */}
                  <div className="d-flex flex-column justify-content-center">
                    <h3
                      style={{
                        fontSize: "22px",
                        fontWeight: "800",
                        textTransform: "uppercase",
                        color: "#1D3557",
                        margin: 0, // Hapus margin bawaan h3 agar tidak merusak alignment
                        lineHeight: "1.2",
                      }}
                    >
                      Detail Pengajuan
                    </h3>
                    <div className="d-flex align-items-center mt-1">
                      <span className="text-muted small fw-bold mr-1">ID:</span>
                      <span
                        className="text-primary fw-800"
                        style={{ fontSize: "14px", letterSpacing: "0.5px" }}
                      >
                        {valDetail.id_pinjaman}
                      </span>

                      {/* IKON SALIN DENGAN NOTIFIKASI SWAL */}
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>Salin ID</Tooltip>}
                      >
                        <i
                          className="far fa-copy ml-2 text-muted"
                          style={{
                            cursor: "pointer",
                            fontSize: "14px",
                            transition: "all 0.2s",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.color = "#007bff")
                          }
                          onMouseOut={(e) =>
                            (e.currentTarget.style.color = "#6c757d")
                          }
                          onClick={() => {
                            // 1. Fungsi Salin
                            navigator.clipboard.writeText(
                              valDetail.id_pinjaman,
                            );

                            // 2. Munculkan Notifikasi
                            Swal.fire({
                              icon: "success",
                              title: "ID Tersalin!",
                              text: valDetail.id_pinjaman,
                              showConfirmButton: false,
                              timer: 1000, // Hilang otomatis dalam 1.2 detik
                              width: "500px",
                              customClass: {
                                title: "fs-5", // Ukuran font judul lebih kecil agar proporsional
                              },
                            });
                          }}
                        ></i>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>

                {/* ACTION BUTTONS: Grouping */}
                <div className="d-flex flex-wrap justify-content-center gap-2">
                  {(auth.role === "super admin" || auth.role === "admin") && (
                    <Button
                      disabled={valDetail.statusPengajuan === "Disetujui"}
                      className="btn-fill border-0 shadow-sm mx-1"
                      style={{
                        backgroundColor: "#116D6E",
                        borderRadius: "10px",
                        fontWeight: "700",
                        fontSize: "12px",
                        padding: "10px 15px",
                      }}
                      onClick={() => {
                        setIdPengajuan(valDetail.id_pinjaman);
                        setModalUpdateStatus(true);
                      }}
                    >
                      <i className="fas fa-edit mr-2"></i> UPDATE MANUAL
                    </Button>
                  )}

                  {[
                    "super admin",
                    "admin",
                    "koordinator wilayah",
                    "area manager",
                    "supervisor",
                  ].includes(auth.role) && (
                    <>
                      <Button
                        disabled={
                          valDetail.statusPengajuan !== "Menunggu Konfirmasi"
                        }
                        className="btn-fill border-0 shadow-sm mx-1"
                        style={{
                          backgroundColor: "#F63F4B",
                          borderRadius: "10px",
                          fontWeight: "700",
                          fontSize: "12px",
                          padding: "10px 15px",
                        }}
                        onClick={() => {
                          setIdPengajuan(valDetail.id_pinjaman);
                          setModalRevisi(true);
                        }}
                      >
                        <i className="fas fa-undo mr-2"></i> REVISI
                      </Button>
                      <Button
                        disabled={
                          valDetail.statusPengajuan !== "Menunggu Konfirmasi"
                        }
                        className="btn-fill border-0 shadow-sm mx-1"
                        style={{
                          backgroundColor: "#1D3557",
                          borderRadius: "10px",
                          fontWeight: "700",
                          fontSize: "12px",
                          padding: "10px 15px",
                        }}
                        onClick={ajukanPengajuan}
                      >
                        <i className="fas fa-paper-plane mr-2"></i> AJUKAN
                      </Button>
                    </>
                  )}
                </div>
              </Card.Header>

              <hr className="mx-4 my-2 opacity-50" />

              <Card.Body className="px-4 pb-4">
                {/* BANNER STATUS: Elegant Alert Style */}
                <div
                  className="d-flex align-items-center p-3 mb-4 shadow-sm"
                  style={{
                    backgroundColor: statusStyle(valDetail.statusPengajuan)
                      .backgroundColor,
                    borderRadius: "15px",
                    borderLeft: `6px solid ${statusStyle(valDetail.statusPengajuan).textColor}`,
                  }}
                >
                  <div className="mr-3 ml-2">
                    <i
                      className="fas fa-info-circle fa-2x"
                      style={{
                        color: statusStyle(valDetail.statusPengajuan).textColor,
                      }}
                    ></i>
                  </div>
                  <div>
                    <h6
                      className="fw-800 mb-1"
                      style={{
                        color: statusStyle(valDetail.statusPengajuan).textColor,
                      }}
                    >
                      STATUS: {valDetail.statusPengajuan.toUpperCase()}
                    </h6>
                    <p className="mb-0 small text-dark opacity-75">
                      {valDetail.statusPengajuan === "Menunggu Konfirmasi" &&
                        "Pengajuan Anda sedang menunggu tahap pengecekan."}
                      {valDetail.statusPengajuan === "Diproses" &&
                        "Pengajuan sedang dalam proses oleh pihak Bank KALTIMTARA."}
                      {valDetail.statusPengajuan === "Revisi" &&
                        (valDetail.history[0]?.keterangan ||
                          "Harap perbaiki data sesuai instruksi.")}
                      {valDetail.statusPengajuan === "Disetujui" &&
                        "Pengajuan pinjaman telah disetujui oleh pihak Bank KALTIMTARA."}
                      {valDetail.statusPengajuan === "Ditolak" &&
                        "Pengajuan pinjaman telah ditolak oleh pihak Bank KALTIMTARA."}
                      {valDetail.statusPengajuan === "Diajukan" &&
                        "Pengajuan telah diajukan ke pihak Bank KALTIMTARA."}
                    </p>
                  </div>
                </div>

                <Tab.Container id="detail-tabs" defaultActiveKey="step1">
                  <div className="d-flex justify-content-center mb-4">
                    <Nav
                      variant="pills"
                      className="bg-light p-1 shadow-inner"
                      style={{
                        borderRadius: "12px",
                        border: "1px solid #e2e8f0",
                        display: "inline-flex", // Membuat lebar mengikuti jumlah tab
                        flexWrap: "nowrap",
                        width: "auto", // Mencegah width 100%
                      }}
                    >
                      <Nav.Item>
                        <Nav.Link
                          eventKey="step1"
                          className="custom-step-pill px-4"
                        >
                          Nasabah
                        </Nav.Link>
                      </Nav.Item>
                      {valDetail.statusMenikah === "Kawin" && (
                        <Nav.Item>
                          <Nav.Link
                            eventKey="step2"
                            className="custom-step-pill px-4"
                          >
                            Pasangan
                          </Nav.Link>
                        </Nav.Item>
                      )}
                      <Nav.Item>
                        <Nav.Link
                          eventKey="step3"
                          className="custom-step-pill px-4"
                        >
                          Pekerjaan
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="step4"
                          className="custom-step-pill px-4"
                        >
                          Pinjaman
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="step5"
                          className="custom-step-pill px-4"
                        >
                          Jaminan
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link
                          eventKey="step6"
                          className="custom-step-pill px-4"
                        >
                          Dokumen
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </div>

                  <Tab.Content className="mt-3 animation-fade">
                    <Tab.Pane eventKey="step1">
                      <Step1 />
                    </Tab.Pane>

                    <Tab.Pane eventKey="step2">
                      <Step2 />
                    </Tab.Pane>

                    <Tab.Pane eventKey="step3">
                      <Step3 />
                    </Tab.Pane>

                    <Tab.Pane eventKey="step4">
                      <Step4 />
                    </Tab.Pane>

                    <Tab.Pane eventKey="step5">
                      <Step5 />
                    </Tab.Pane>

                    <Tab.Pane eventKey="step6">
                      <Step6 />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
                <style>{`
  .custom-step-pill {
    color: #64748b !important;
    font-weight: 600 !important;
    font-size: 14px !important;
    border-radius: 10px !important;
    padding: 8px 20px !important;
    transition: all 0.3s ease;
  }
  .custom-step-pill.active {
    background-color: #3b82f6 !important; /* Biru seperti di gambar */
    color: white !important;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3) !important;
  }
  .shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06) !important;
  }
`}</style>
              </Card.Body>
            </Card>
          </Col>

          {/* PREVIEW DOKUMEN (SIDEBAR) */}
          {pengajuan.valueCol !== "12" && (
            <Col lg={pengajuan.valueColPrev} md="12" className="mt-4 mt-lg-0">
              <Card
                className="border-0 shadow-sm sticky-top"
                style={{ borderRadius: "20px", top: "20px" }}
              >
                <Card.Header className="bg-white border-0 pt-4 px-4 d-flex align-items-center justify-content-between">
                  <h5 className="fw-800 text-dark mb-0">PREVIEW DOKUMEN</h5>
                  <Button
                    variant="link"
                    className="text-danger p-0 shadow-none"
                    onClick={() => dispatch({ type: "HIDE_DOKUMEN" })}
                  >
                    <i className="fas fa-times-circle fa-lg"></i>
                  </Button>
                </Card.Header>
                <Card.Body className="p-3">
                  <div
                    className="rounded-lg overflow-hidden border shadow-inner"
                    style={{ borderRadius: "15px", height: "700px" }}
                  >
                    <iframe
                      src={urlPreview}
                      width="100%"
                      height="100%"
                      frameBorder="0"
                    />
                  </div>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>

        <style>{`
    .custom-step-pill {
      color: #64748b !important;
      font-weight: 700 !important;
      font-size: 12px !important;
      border-radius: 10px !important;
      padding: 10px 20px !important;
      white-space: nowrap;
    }
    .custom-step-pill.active {
      background-color: #3090C7 !important;
      color: white !important;
      box-shadow: 0 4px 10px rgba(48, 144, 199, 0.3) !important;
    }
    .animation-fade { animation: fadeIn 0.3s ease-in-out; }
    @keyframes fadeIn { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: translateY(0); } }
    .shadow-inner { box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.05); }
    .gap-2 { gap: 0.5rem; }
  `}</style>
      </Container>

      <Card
        className="border-0 shadow-sm overflow-hidden"
        style={{ borderRadius: "20px" }}
      >
        <Card.Header className="bg-white border-0 pt-4 px-4">
          <div className="d-flex align-items-center">
            <div
              style={{
                width: "8px",
                height: "25px",
                backgroundColor: "#113946",
                borderRadius: "10px",
                marginRight: "12px",
              }}
            />
            <Card.Title
              as="h4"
              style={{
                color: "#1D3557",
                fontWeight: "800",
                textTransform: "uppercase",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              HISTORY PENGAJUAN
            </Card.Title>
          </div>
          <p className="text-muted small mt-2 mb-0">
            Log aktivitas perjalanan berkas pengajuan nasabah
          </p>
        </Card.Header>

        <Card.Body className="px-0">
          {" "}
          {/* Padding 0 agar timeline mepet ke pinggir card */}
          <div
            style={{
              maxHeight: "550px",
              overflowY: "auto",
              padding: "20px 10px",
              backgroundColor: "#F8F9FC", // Background soft agar elemen timeline lebih menonjol
            }}
            className="custom-scrollbar"
          >
            <VerticalTimeline
              lineColor="#CBD5E1"
              animate={true}
              layout="1-column-left"
            >
              {valDetail.history.map((item, index) => {
                // Tentukan warna berdasarkan status
                const statusColors = {
                  "Menunggu Konfirmasi": "#FFAF05",
                  Diproses: "#FA5D02",
                  Disetujui: "#5AC967",
                  Revisi: "#FF2B4B",
                  Diajukan: "#1D3557", // Tambahan warna untuk status diajukan
                  Default: "#E10F00",
                };
                const activeColor =
                  statusColors[item.status] || statusColors["Default"];

                return (
                  <VerticalTimelineElement
                    key={index}
                    className="vertical-timeline-element--work"
                    contentStyle={{
                      background: "#fff",
                      color: "#1D3557",
                      boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
                      borderRadius: "15px",
                      borderTop: `6px solid ${activeColor}`,
                      padding: "1.5rem",
                    }}
                    contentArrowStyle={{ borderRight: "7px solid  #fff" }}
                    date={moment(item.date).format("DD MMM YYYY | HH:mm")}
                    dateClassName="text-muted fw-bold"
                    iconStyle={{
                      background: activeColor,
                      color: "#fff",
                      boxShadow: `0 0 0 4px #fff, inset 0 2px 0 rgba(0,0,0,0.08), 0 3px 0 4px rgba(0,0,0,0.05)`,
                      // TAMBAHKAN INI UNTUK CENTER:
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    icon={
                      <i
                        className={`fas ${
                          item.status === "Disetujui"
                            ? "fa-check"
                            : item.status === "Revisi"
                              ? "fa-exclamation-triangle"
                              : "fa-history"
                        }`}
                        style={{ fontSize: "20px" }} // Ukuran ikon dipastikan konsisten
                      ></i>
                    }
                  >
                    <h5 className="fw-800 mb-2" style={{ color: activeColor }}>
                      {item.status.toUpperCase()}
                    </h5>

                    <div
                      className="bg-light p-3"
                      style={{ borderRadius: "10px" }}
                    >
                      <div className="d-flex align-items-start">
                        <i className="fas fa-comment-dots mt-1 mr-3 text-muted"></i>
                        <div>
                          <span className="d-block text-muted small fw-bold uppercase mb-1">
                            Keterangan / Catatan:
                          </span>
                          <p
                            className="mb-0 text-dark fw-600"
                            style={{ fontSize: "13px", lineHeight: "1.5" }}
                          >
                            {!item.keterangan || item.keterangan === ""
                              ? "Tidak ada catatan tambahan."
                              : item.keterangan}
                          </p>
                        </div>
                      </div>
                    </div>
                  </VerticalTimelineElement>
                );
              })}
            </VerticalTimeline>
          </div>
        </Card.Body>

        {/* Custom Scrollbar Styling */}
        <style>{`
    .custom-scrollbar::-webkit-scrollbar {
      width: 6px;
    }
    .custom-scrollbar::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    .custom-scrollbar::-webkit-scrollbar-thumb {
      background: #CBD5E1;
      border-radius: 10px;
    }
    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
      background: #94A3B8;
    }
    .vertical-timeline::before {
      left: 18px !important; /* Menyesuaikan garis timeline karena layout kiri */
    }
    @media only screen and (min-width: 1170px) {
      .vertical-timeline-element-content {
        margin-left: 60px !important;
        width: 90% !important;
      }
    }
  `}</style>
      </Card>
    </>
  );
}

export default indexSteps;

{
  /* {valDetail.stepEmpat.tujuanPenggunaan === "2" ? (
        <>
          <Card>
            <Card.Header>
              <Card.Title
                as="h3"
                style={{
                  color: "black",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                }}
              >
                Analisa Slik
                <hr></hr>
              </Card.Title>
            </Card.Header>

            <Card.Body>
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "8px",
                  padding: "10px 20px",
                  boxShadow: "0 3px 8px rgba(0, 1, 0, 0.3)",
                  width: "50%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                }}
              >
                <div
                  style={{
                    textTransform: "uppercase",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  pemilik usaha
                  <hr></hr>
                </div>

                <div className="row">
                  <div className="col-8">
                    <Row style={{ marginTop: 10 }}>
                      <Col sm="4">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          nama
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                          }}
                        >
                          {!valDetail.pemilikUsaha
                            ? "-"
                            : valDetail.pemilikUsaha.nama}
                        </label>
                      </Col>
                      <Col sm="4">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          nik
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                          }}
                        >
                          {!valDetail.pemilikUsaha
                            ? "-"
                            : valDetail.pemilikUsaha.nik}
                        </label>
                      </Col>
                      <Col sm="4">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          tgl lahir
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                          }}
                        >
                          {!valDetail.pemilikUsaha
                            ? "-"
                            : moment(
                                valDetail.pemilikUsaha.tanggalLahir
                              ).format("DD MMMM YYYY")}
                        </label>
                      </Col>
                      <Col sm="4">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          No Telepon
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                          }}
                        >
                          {!valDetail.pemilikUsaha
                            ? "-"
                            : valDetail.pemilikUsaha.noTelp}
                        </label>
                      </Col>
                      <Col sm="4">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                            fontWeight: "bold",
                            textTransform: "capitalize",
                          }}
                        >
                          Alamat
                        </label>
                      </Col>
                      <Col sm="o">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                          }}
                        >
                          :
                        </label>
                      </Col>
                      <Col sm="6">
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 16,
                            color: "black",
                          }}
                        >
                          {!valDetail.pemilikUsaha
                            ? "-"
                            : valDetail.pemilikUsaha.alamat}
                        </label>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>

              <Tab.Container
                id="plain-tabs-example"
                defaultActiveKey="ringkasan"
              >
                <Nav role="tablist" variant="tabs">
                  <Nav.Item>
                    <Nav.Link
                      eventKey="ringkasan"
                      style={{ color: "#3090C7", fontWeight: "bold" }}
                    >
                      List Usaha
                    </Nav.Link>
                  </Nav.Item>

                  <Nav.Item>
                    <Nav.Link
                      eventKey="scoring"
                      style={{ color: "#3090C7", fontWeight: "bold" }}
                    >
                      Scoring
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="ringkasan">
                    <Ringkasan />
                  </Tab.Pane>
                  <Tab.Pane eventKey="scoring">
                    <Scoring />
                  </Tab.Pane>

                  <Tab.Pane eventKey="export"><Step3 /></Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Card.Body>
          </Card>
        </>
      ) : null} */
}
